import { useMemo } from 'react';
import { theme } from '@fiverr-private/theme';

export const useIsLessThanMdScreen = () =>
    useMemo(() => typeof window !== 'undefined' && window.innerWidth < theme.numericBreakpoints.md, []);
